import { Conversation, UpdateConversationHandoffStatusDto } from 'shared/interfaces/Conversation';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const conversationHandoffBaseEndpoint = '/conversation-handoff';

export const ConversationHandoffService = {
  updateStatus: async (
    updateConversationHandoffStatusDto: UpdateConversationHandoffStatusDto
  ): Promise<Conversation> => {
    const response = await axiosBaseInstance({
      method: 'put',
      url: `${conversationHandoffBaseEndpoint}/status`,
      data: updateConversationHandoffStatusDto
    });

    return response.data;
  }
};
